export function Updates() {
  return (
    <div className="min-h-screen bg-white">
      <main className="pt-32 px-8 pb-20">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-medium mb-12">更新日志</h1>
          
          <div className="space-y-12">
            {/* 版本 1.0 */}
            <div className="border-l-2 border-[#3b82f6] pl-8">
              <div className="flex items-baseline gap-4 mb-4">
                <h3 className="text-2xl font-medium">版本 1.0</h3>
                <span className="text-sm text-gray-500">2026.2.09</span>
              </div>
              <ul className="space-y-2 text-sm text-gray-700" style={{ lineHeight: '1.8' }}>
                <li>• 正式发布 三款核心工具</li>
                <li>• 稳定版本 完成工具整体稳定性优化与性能调校</li>
                <li>• 上线 资源库模块</li>
                <li>• 集中整理视觉参考、工具延展资源</li>
                <li>• 推出 新年限定活动！免费领红包封面。</li>
                <li>• 更新了国内访问速度慢的问题</li>
              </ul>
            </div>

            {/* 版本 0.9 Beta */}
            <div className="border-l-2 border-gray-300 pl-8 opacity-60">
              <div className="flex items-baseline gap-4 mb-4">
                <h3 className="text-2xl font-medium">版本 0.9 Beta</h3>
                <span className="text-sm text-gray-500">2025.12.01</span>
              </div>
              <ul className="space-y-2 text-sm text-gray-700" style={{ lineHeight: '1.8' }}>
                <li>• 内部测试版本发布</li>
                <li>• 完成基础架构搭建</li>
                <li>• 初步设计系统建立</li>
                <li>• 核心功能原型开发</li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}